import gaugeIcon from "../../../assets/images/dashboardItems/gauge.png";
import gaugeHoverIcon from "../../../assets/images/dashboardItems/gaugeHover.png";
import jsonIcon from "../../../assets/images/dashboardItems/json.png";
import jsonHoverIcon from "../../../assets/images/dashboardItems/jsonHover.png";
import plotIcon from "../../../assets/images/dashboardItems/plot.png";
import plotHoverIcon from "../../../assets/images/dashboardItems/plotHover.png";
import valueIcon from "../../../assets/images/dashboardItems/value.png";
import valueHoverIcon from "../../../assets/images/dashboardItems/valueHover.png";

const dashboardItems = {
	title: "Dashboard",
	items: {
		gauge: {
			icon: gaugeIcon,
			iconHover: gaugeHoverIcon,
			title: "Gauge",
			variables: {
				variable: {
					type: "text",
					name: "Variable",
					placeholder: "Enter variable name",
					value: "",
				},
				minValue: {
					type: "number",
					name: "Min Value",
					placeholder: "Enter minimum value",
					value: 0,
					precision: 1,
					step: 1,
				},
				maxValue: {
					type: "number",
					name: "Max Value",
					placeholder: "Enter maximum value",
					value: 100,
					precision: 1,
					step: 1,
				},
				leftColor: {
					type: "text",
					name: "Left Color",
					placeholder: "Enter color for left side",
					value: "#DE162F",
				},
				rightColor: {
					type: "text",
					name: "Right Color",
					placeholder: "Enter color for right side",
					value: "#7ABF43",
				},
				levels: {
					type: "number",
					name: "Levels",
					placeholder: "Enter number of levels",
					value: 20,
					precision: 0,
					step: 1,
				},
				hideText: {
					type: "boolean",
					name: "Hide Text",
					placeholder: "Hide text display",
					value: false,
				},
				unit: {
					type: "text",
					name: "Unit",
					placeholder: "Enter unit",
					value: "%",
				},
				decimal: {
					type: "number",
					name: "Decimals",
					placeholder: "Enter decimal places",
					value: 1,
				},
			},
			minWidth: 1,
			minHeight: 1,
			startWidth: 3,
			startHeight: 3,
			tooltip: {
				header: "Gauge",
				body: "A gauge in which you can preview a value from a given variable.",
			},
		},
		json: {
			icon: jsonIcon,
			iconHover: jsonHoverIcon,
			title: "JSON",
			variables: {
				variable: {
					type: "text",
					name: "Variable",
					placeholder: "Enter variable name",
					value: "",
				},
			},
			minWidth: 1,
			minHeight: 1,
			startWidth: 3,
			startHeight: 3,
			tooltip: {
				header: "Json Viewer",
				body: "A component in which you can preview a json object from a given variable.",
			},
		},
		plot: {
			icon: plotIcon,
			iconHover: plotHoverIcon,
			title: "Plot",
			variables: {
				variable: {
					type: "text",
					name: "Variable",
					placeholder: "Enter variable name",
					value: "",
				},
				showLegend: {
					type: "boolean",
					name: "Show Legend",
					placeholder: "Show legend in plot",
					value: true,
				},
				legendPosition: {
					type: "select",
					name: "Legend Position",
					placeholder: "Select legend position",
					value: "Top Right",
					options: ["Top Right", "Top Left", "Bottom Right", "Bottom Left"],
					needs: { showLegend: [true] },
				},
				plotName: {
					type: "text",
					name: "Plot Name",
					placeholder: "Enter plot name",
					value: "Plot",
				},
				xAxisLabel: {
					type: "text",
					name: "X-Axis Label",
					placeholder: "Enter x-axis label",
					value: "X-Axis",
				},
				yAxisLabel: {
					type: "text",
					name: "Y-Axis Label",
					placeholder: "Enter y-axis label",
					value: "Y-Axis",
				},
				color: {
					type: "text",
					name: "Color",
					placeholder: "Enter line color",
					value: "#0000FF",
				},
				chartType: {
					type: "select",
					name: "Chart Type",
					placeholder: "Select chart type",
					value: "Line",
					options: ["Line", "Bar", "Scatter"],
				},
				maxValues: {
					type: "number",
					name: "Max Values to Display (0 for unlimited)",
					placeholder: "Enter maximum number of values to display",
					value: 0,
					precision: 0,
					step: 1,
				},
			},
			minWidth: 1,
			minHeight: 1,
			startWidth: 3,
			startHeight: 3,
			tooltip: {
				header: "Plot Viewer",
				body: "A component in which you can preview a value from a given variable over time.",
			},
		},
		value: {
			icon: valueIcon,
			iconHover: valueHoverIcon,
			title: "Value",
			variables: {
				variable: {
					type: "text",
					name: "Variable",
					placeholder: "Enter variable name",
					value: "",
				},
				unit: {
					type: "text",
					name: "Unit",
					placeholder: "Enter unit",
					value: "",
				},
				decimal: {
					type: "number",
					name: "Decimals",
					placeholder: "Enter decimal places",
					value: 1,
				},
			},
			minWidth: 1,
			minHeight: 1,
			startWidth: 2,
			startHeight: 2,
			tooltip: {
				header: "Value",
				body: "Display the value of a given variable.",
			},
		},
	},
};

export default dashboardItems;
